<template>
  <!-- The sidebar and the page share one ground. -->
  <main class="flex flex-1 overflow-x-clip bg-ground define-width-0-100-100">
    <slot />
  </main>
</template>
